export function orderByDateDesc(a, b) {
  return new Date(b) - new Date(a);
}
